export const LuxPlusPartnerPromoClassifier = {
  TURO: 'TURO:lux_plus_au2',
  HELLOFRESH: 'HELLOFRESH:lux_plus_au2',
  WINE_SELECTORS: 'WINE_SELECTORS:lux_plus_au2',
} as const

/**
 * Maps URL-derived benefit slugs (from `?benefit=<slug>`) to partner promo
 * classifier IDs. Slugs must match the values used in deep-link URLs.
 */
export const PARTNER_PROMO_SLUG_TO_CLASSIFIER: Record<string, LuxPlusPartnerPromoClassifierType> = {
  'turo': LuxPlusPartnerPromoClassifier.TURO,
  'hello-fresh': LuxPlusPartnerPromoClassifier.HELLOFRESH,
  'wine-selectors': LuxPlusPartnerPromoClassifier.WINE_SELECTORS,
}

export type LuxPlusPartnerPromoClassifierType = typeof LuxPlusPartnerPromoClassifier[keyof typeof LuxPlusPartnerPromoClassifier]

export const PARTNER_PROMO_CLASSIFIER_VALUES = new Set<string>(
  Object.values(LuxPlusPartnerPromoClassifier),
)
